export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-foreground-300">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="font-heading text-lg text-white mb-4">五一吃瓜网</h3>
            <p className="text-xs leading-relaxed text-foreground-400">
              聚焦网络热门事件，搜罗今日最新热点、热搜事件与吃瓜事件汇总，持续追踪热门爆料。
              从娱乐圈八卦到社会热点，从直播翻车到网红人设崩塌——每一个引发全网热议的网络大事件，我们都为你完整记录。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><a href="#hero" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</a></li>
              <li><a href="#index" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">热门专题合集</a></li>
              <li><a href="#carousel" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">焦点追踪</a></li>
              <li><a href="#cards" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">热门事件</a></li>
              <li><a href="#updates" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">最新快讯</a></li>
              <li><a href="#contact" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">爆料投稿</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">热门话题</h4>
            <ul className="space-y-2">
              <li><a href="#topics" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">网络热门事件</a></li>
              <li><a href="#topics" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">今日热门事件</a></li>
              <li><a href="#topics" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">最新网络热点</a></li>
              <li><a href="#topics" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">吃瓜事件汇总</a></li>
              <li><a href="#topics" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">热门爆料</a></li>
              <li><a href="#topics" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">热搜事件</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              合作伙伴信息敬请期待
            </p>
            <h4 className="text-sm font-semibold text-white mt-6 mb-3">联系与合作</h4>
            <p className="text-xs text-foreground-400">
              <i className="ri-mail-line mr-1"></i>tips@51chigua.com
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 五一吃瓜网 - 网络热门事件追踪平台。本站内容均来源于公开网络信息，仅供吃瓜交流，不构成任何建议。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</a>
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">常见问答</a>
            <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}